export default __webpack_public_path__ + "8bb2c42aa3b16f881f7724d721545209.svg";